(function () {
  'use strict';

  function formatMoney(cents, format) {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var formatString = format || '${{amount}}';

    function defaultOption(opt, def) {
      return typeof opt === 'undefined' ? def : opt;
    }

    function formatWithDelimiters(number, precision, thousands, decimal) {
      precision = defaultOption(precision, 2);
      thousands = defaultOption(thousands, ',');
      decimal = defaultOption(decimal, '.');
      if (isNaN(number) || number == null) return 0;
      number = (number / 100.0).toFixed(precision);
      var parts = number.split('.');
      var dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      var centsPart = parts[1] ? decimal + parts[1] : '';
      return dollars + centsPart;
    }

    var match = formatString.match(placeholderRegex);
    if (!match) return cents;

    var value = '';
    switch (match[1]) {
      case 'amount':
        value = formatWithDelimiters(cents, 2);
        break;
      case 'amount_no_decimals':
        value = formatWithDelimiters(cents, 0);
        break;
      case 'amount_with_comma_separator':
        value = formatWithDelimiters(cents, 2, '.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(cents, 0, '.', ',');
        break;
      default:
        value = formatWithDelimiters(cents, 2);
    }

    return formatString.replace(placeholderRegex, value);
  }

  function updateCartBadge() {
    fetch('/cart.js')
      .then(function (r) {
        return r.json();
      })
      .then(function (cart) {
        var badge = document.getElementById('ch-cart-count');
        if (badge) {
          badge.textContent = cart.item_count;
          badge.style.display = cart.item_count > 0 ? 'flex' : 'none';
        }
        document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: cart } }));
      })
      .catch(function () {});
  }

  function openCartDrawer() {
    var drawer = document.querySelector('theme-drawer#cart-drawer');
    if (drawer && typeof drawer.showDialog === 'function') {
      drawer.showDialog();
      return;
    }
    var trigger = document.querySelector('[aria-controls="cart-drawer"]');
    if (trigger) trigger.click();
  }

  function initStickyPurchaseBar(root) {
    var purchaseActions = root.querySelector('.cpd__actions');
    var stickyBar = root.querySelector('.cpd__sticky-bar');
    if (!purchaseActions || !stickyBar || !('IntersectionObserver' in window)) return;

    var updateVisibility = function () {
      var actionsRect = purchaseActions.getBoundingClientRect();
      var shouldShow = window.matchMedia('(max-width: 860px)').matches && actionsRect.bottom <= 0;
      stickyBar.classList.toggle('is-visible', shouldShow);
      stickyBar.setAttribute('aria-hidden', shouldShow ? 'false' : 'true');
    };

    var updateQueued = false;
    var queueVisibilityUpdate = function () {
      if (updateQueued) return;
      updateQueued = true;
      window.requestAnimationFrame(function () {
        updateQueued = false;
        updateVisibility();
      });
    };

    var observer = new IntersectionObserver(
      queueVisibilityUpdate,
      { threshold: 0.1 }
    );

    observer.observe(purchaseActions);
    window.addEventListener('scroll', queueVisibilityUpdate, { passive: true });
    window.addEventListener('resize', queueVisibilityUpdate);
    updateVisibility();
  }

  function addToCart(variantId, quantity) {
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ id: variantId, quantity: quantity || 1 }),
    }).then(function (res) {
      if (!res.ok) throw new Error('Add failed');
      return res.json();
    });
  }

  function initSection(root) {
    var sectionId = root.dataset.sectionId;
    if (!sectionId) return;

    initStickyPurchaseBar(root);

    var moneyFormat = root.dataset.moneyFormat || '${{amount}}';

    var mainImage = root.querySelector('.cpd__gallery-image') || root.querySelector('.cpd__gallery-main img');
    var thumbs = root.querySelectorAll('[data-cpd-thumb]');
    var variantsJsonEl = root.querySelector('[data-cpd-variants]');
    if (!variantsJsonEl) return;

    var variants = JSON.parse(variantsJsonEl.textContent);
    var variantMediaMap = {};
    var variantMediaEl = root.querySelector('[data-cpd-variant-media]');
    if (variantMediaEl) {
      try {
        variantMediaMap = JSON.parse(variantMediaEl.textContent);
      } catch (e) {
        variantMediaMap = {};
      }
    }
    var colorMediaMap = {};
    var colorMediaEl = root.querySelector('[data-cpd-color-media]');
    if (colorMediaEl) {
      try {
        colorMediaMap = JSON.parse(colorMediaEl.textContent);
      } catch (e) {
        colorMediaMap = {};
      }
    }
    var colorOptionIndex = parseInt(root.dataset.colorOptionIndex || '0', 10);
    var radios = root.querySelectorAll('[data-cpd-option]');
    var inputId = root.querySelector('[data-cpd-variant-id]');
    var priceEl = root.querySelector('[data-cpd-price]');
    var compareEl = root.querySelector('[data-cpd-compare]');
    var variantSubtitleEl = root.querySelector('[data-cpd-variant-subtitle]');
    var stockEl = root.querySelector('[data-cpd-stock]');
    var buyBtn = root.querySelector('[data-cpd-buy-now]');
    var cartBtn = root.querySelector('[data-cpd-add-cart]');
    var stickyBuyBtn = root.querySelector('[data-cpd-sticky-buy]');
    var stickyCartBtn = root.querySelector('[data-cpd-sticky-cart]');
    var qtyInput = root.querySelector('[data-cpd-qty]');
    var qtyMinus = root.querySelector('[data-cpd-qty-minus]');
    var qtyPlus = root.querySelector('[data-cpd-qty-plus]');
    var form = root.querySelector('[data-cpd-form]');

    function getSelectedOptions() {
      return {
        opt1: root.querySelector('[data-cpd-option][data-index="option1"]:checked')?.value,
        opt2: root.querySelector('[data-cpd-option][data-index="option2"]:checked')?.value,
        opt3: root.querySelector('[data-cpd-option][data-index="option3"]:checked')?.value,
      };
    }

    function findVariant() {
      var opts = getSelectedOptions();
      return variants.find(function (v) {
        return (
          v.option1 === opts.opt1 &&
          v.option2 === (opts.opt2 || null) &&
          v.option3 === (opts.opt3 || null)
        );
      });
    }

    function findBestPartialVariant() {
      var opts = getSelectedOptions();
      var best = null;
      var bestScore = -1;
      variants.forEach(function (variant) {
        var score = 0;
        if (opts.opt1 && variant.option1 === opts.opt1) score++;
        if (opts.opt2 && variant.option2 === opts.opt2) score++;
        if (opts.opt3 && variant.option3 === opts.opt3) score++;
        if (score > bestScore) {
          bestScore = score;
          best = variant;
        }
      });
      return bestScore > 0 ? best : null;
    }

    function getVariantImageSrc(variant) {
      if (!variant) return null;
      var featured = variant.featured_image || variant.featured_media;
      if (!featured) return null;
      return featured.src || (featured.preview && featured.preview.src) || null;
    }

    function imageFileKey(src) {
      if (!src) return '';
      var path = src.replace(/^https?:/, '').split('?')[0];
      var file = path.split('/').pop() || '';
      return file.replace(/_\d+x(\d+)?(@2x)?(?=\.[a-z]+$)/i, '').replace(/\.[a-z]+$/i, '').toLowerCase();
    }

    function getSelectedColorValue() {
      if (!colorOptionIndex) return null;
      var colorRadio = root.querySelector(
        '[data-cpd-option][data-index="option' + colorOptionIndex + '"]:checked'
      );
      return colorRadio ? colorRadio.value : null;
    }

    function findVariantForGallery() {
      var exact = findVariant();
      if (exact) return exact;

      var colorVal = getSelectedColorValue();
      if (colorVal) {
        var colorMatches = variants.filter(function (variant) {
          return variant['option' + colorOptionIndex] === colorVal;
        });
        if (colorMatches.length) {
          var withMedia = colorMatches.find(function (variant) {
            return variantMediaMap[String(variant.id)];
          });
          return withMedia || colorMatches[0];
        }
      }

      return findBestPartialVariant();
    }

    function resolveGalleryMediaId() {
      var colorVal = getSelectedColorValue();
      if (colorVal && colorMediaMap[colorVal]) {
        return colorMediaMap[colorVal];
      }

      if (colorVal) {
        for (var i = 0; i < thumbs.length; i++) {
          var linked = thumbs[i].dataset.linkedColors;
          if (!linked) continue;
          var colors = linked.split('|');
          if (colors.indexOf(colorVal) !== -1) {
            return parseInt(thumbs[i].dataset.mediaId, 10);
          }
        }
      }

      var variant = findVariantForGallery();
      if (variant && variantMediaMap[String(variant.id)]) {
        return variantMediaMap[String(variant.id)];
      }

      return null;
    }

    function setMainImageSrc(src) {
      if (!mainImage || !src) return;
      mainImage.style.opacity = '0';
      setTimeout(function () {
        mainImage.src = src;
        if (mainImage.srcset) mainImage.removeAttribute('srcset');
        if (mainImage.sizes) mainImage.removeAttribute('sizes');
        mainImage.style.opacity = '1';
      }, 200);
    }

    function updateGallery() {
      if (!mainImage) return;

      var mediaId = resolveGalleryMediaId();
      if (mediaId) {
        var targetThumb = root.querySelector('[data-cpd-thumb][data-media-id="' + mediaId + '"]');
        if (targetThumb) {
          activateThumb(targetThumb);
          return;
        }
      }

      var variant = findVariantForGallery();
      if (!variant) return;

      var variantSrc = getVariantImageSrc(variant);
      if (!variantSrc) return;

      var variantKey = imageFileKey(variantSrc);
      for (var i = 0; i < thumbs.length; i++) {
        var thumb = thumbs[i];
        if (imageFileKey(thumb.dataset.imageSrc) === variantKey) {
          activateThumb(thumb);
          return;
        }
      }

      setMainImageSrc(variantSrc);
    }

    function switchGalleryForVariant() {
      updateGallery();
    }

    function updateSpecValues(variant) {
      root.querySelectorAll('[data-cpd-spec-dynamic]').forEach(function (row) {
        var key = row.dataset.cpdSpecDynamic;
        var valEl = row.querySelector('[data-cpd-spec-val]');
        if (!valEl) return;
        if (key === 'ram' && variant.option1) {
          var ram = [variant.option1, variant.option2, variant.option3].find(function (o) {
            return o && /gb/i.test(o) && !/\d+\s*gb\s*\/\s*\d+/i.test(o);
          });
          if (ram) valEl.textContent = ram;
        }
        if (key === 'storage') {
          var storage = [variant.option1, variant.option2, variant.option3].find(function (o) {
            return o && (/tb/i.test(o) || /\d+\s*gb/i.test(o));
          });
          if (storage && !/^(\d+\s*gb\s*)?ram/i.test(storage)) valEl.textContent = storage;
        }
      });
    }

    function buildVariantSubtitle(variant) {
      if (!variantSubtitleEl) return;
      var parts = [variant.option1, variant.option2, variant.option3].filter(Boolean);
      var nonColor = parts.filter(function (p) {
        return !/^(peach|navy|blue|green|grey|gray|black|white|silver|gold|mint|cream|pink|purple|red|orange)/i.test(p);
      });
      if (nonColor.length) {
        variantSubtitleEl.textContent = nonColor.join(' / ');
      } else if (parts.length > 1) {
        variantSubtitleEl.textContent = parts.slice(1).join(' / ');
      }
    }

    function applyVariant(variant) {
      if (!variant) {
        if (buyBtn) buyBtn.disabled = true;
        if (cartBtn) cartBtn.disabled = true;
        if (stickyBuyBtn) stickyBuyBtn.disabled = true;
        if (stickyCartBtn) stickyCartBtn.disabled = true;
        if (stockEl) {
          stockEl.textContent = 'Unavailable';
          stockEl.classList.add('is-out');
        }
        switchGalleryForVariant();
        return;
      }

      if (inputId) inputId.value = variant.id;

      var url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url);

      if (priceEl) priceEl.textContent = formatMoney(variant.price, moneyFormat);
      if (compareEl) {
        if (variant.compare_at_price > variant.price) {
          compareEl.textContent = formatMoney(variant.compare_at_price, moneyFormat);
          compareEl.hidden = false;
        } else {
          compareEl.hidden = true;
        }
      }

      buildVariantSubtitle(variant);
      updateSpecValues(variant);

      if (stockEl) {
        if (variant.available) {
          stockEl.textContent = '● In stock';
          stockEl.classList.remove('is-out');
        } else {
          stockEl.textContent = '● Out of stock';
          stockEl.classList.add('is-out');
        }
      }

      var enabled = variant.available;
      if (buyBtn) {
        buyBtn.disabled = !enabled;
        buyBtn.textContent = enabled ? 'Buy Now' : 'Sold Out';
      }
      if (stickyBuyBtn) {
        stickyBuyBtn.disabled = !enabled;
        stickyBuyBtn.textContent = enabled ? 'Buy Now' : 'Sold Out';
      }
      if (cartBtn) {
        cartBtn.disabled = !enabled;
        var cartLabel = cartBtn.querySelector('[data-cpd-cart-label]');
        if (cartLabel) cartLabel.textContent = enabled ? 'Add to Cart' : 'Sold Out';
      }
      if (stickyCartBtn) {
        stickyCartBtn.disabled = !enabled;
        stickyCartBtn.textContent = enabled ? 'Add to Cart' : 'Sold Out';
      }

      switchGalleryForVariant();
    }

    function activateThumb(thumb) {
      thumbs.forEach(function (t) {
        t.classList.remove('is-active');
      });
      thumb.classList.add('is-active');
      setMainImageSrc(thumb.dataset.imageSrc);
    }

    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        activateThumb(thumb);
      });
    });

    radios.forEach(function (radio) {
      radio.addEventListener('change', function () {
        var optionIndex = radio.dataset.index.replace('option', '');
        var selectedDisplay = root.querySelector('[data-cpd-selected-option="' + optionIndex + '"]');
        if (selectedDisplay) selectedDisplay.textContent = radio.value;
        applyVariant(findVariant());
      });
    });

    if (qtyMinus && qtyPlus && qtyInput) {
      qtyMinus.addEventListener('click', function () {
        var val = parseInt(qtyInput.value, 10) || 1;
        if (val > 1) qtyInput.value = val - 1;
      });
      qtyPlus.addEventListener('click', function () {
        var val = parseInt(qtyInput.value, 10) || 1;
        qtyInput.value = val + 1;
      });
    }

    if (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var variant = findVariant();
        if (!variant || !variant.available) return;
        var qty = parseInt(qtyInput?.value, 10) || 1;
        cartBtn.disabled = true;
        if (stickyCartBtn) stickyCartBtn.disabled = true;
        addToCart(variant.id, qty)
          .then(function () {
            updateCartBadge();
            openCartDrawer();
          })
          .catch(function () {
            alert('Could not add to cart. Please try again.');
          })
          .finally(function () {
            var enabled = variant.available;
            if (cartBtn) cartBtn.disabled = !enabled;
            if (stickyCartBtn) stickyCartBtn.disabled = !enabled;
          });
      });
    }

    if (buyBtn) {
      buyBtn.addEventListener('click', handleBuyNow);
    }
    if (stickyBuyBtn) {
      stickyBuyBtn.addEventListener('click', handleBuyNow);
    }

    function handleBuyNow() {
        var variant = findVariant();
        if (!variant || !variant.available) return;
        var qty = parseInt(qtyInput?.value, 10) || 1;
        if (buyBtn) buyBtn.disabled = true;
        if (stickyBuyBtn) stickyBuyBtn.disabled = true;
        addToCart(variant.id, qty)
          .then(function () {
            window.location.href = '/checkout';
          })
          .catch(function () {
            alert('Could not proceed to checkout. Please try again.');
            if (buyBtn) buyBtn.disabled = false;
            if (stickyBuyBtn) stickyBuyBtn.disabled = false;
          });
    }

    applyVariant(findVariant() || variants[0]);
  }

  function initRelatedQuickAdd(root) {
    root.querySelectorAll('[data-cpd-related-atc]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var variantId = btn.dataset.variantId;
        if (!variantId) return;
        btn.disabled = true;
        addToCart(variantId, 1)
          .then(function () {
            btn.classList.add('is-added');
            btn.textContent = 'Added';
            updateCartBadge();
            openCartDrawer();
            setTimeout(function () {
              btn.classList.remove('is-added');
              btn.textContent = 'Add to Cart';
              btn.disabled = false;
            }, 2000);
          })
          .catch(function () {
            btn.disabled = false;
            alert('Could not add to cart.');
          });
      });
    });
  }

  function loadRecommendations(root) {
    var container = root.querySelector('[data-cpd-related-container]');
    if (!container || container.dataset.loaded === 'true') return;

    var url = container.dataset.url;
    if (!url) return;

    fetch(url)
      .then(function (r) {
        return r.text();
      })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var grid = doc.querySelector('[data-cpd-related-grid]');
        if (grid && grid.innerHTML.trim()) {
          container.innerHTML = grid.innerHTML;
          container.dataset.loaded = 'true';
          initRelatedQuickAdd(container);
        }
      })
      .catch(function () {});
  }

  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('[data-cpd-section]').forEach(function (root) {
      initSection(root);
      initRelatedQuickAdd(root);
      loadRecommendations(root);
    });
  });
})();
